import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Article } from "@/lib/types";
import { timeAgo } from "@/lib/api";
import { useArticlePath } from "@/lib/i18n";
import { sectorTrack } from "./SectorHero";

export const SecurityExploits = ({ items }: { items: Article[] }) => {
  const toArticle = useArticlePath();
  if (!items?.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-10" data-testid="defi-security-exploits">
      <h2 className="font-heading font-bold text-white text-lg flex items-center gap-2.5 mb-4">
        <ShieldAlert aria-hidden className="h-[18px] w-[18px] text-[#EF4444]" />
        Security &amp; Exploits
        <span className="font-mono text-[9px] font-bold uppercase tracking-[0.2em] text-gray-500">30D Window</span>
      </h2>
      <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 ${items.length >= 3 ? "lg:grid-cols-4" : ""}`}>
        {items.map((a) => {
          const img = (a as any).lead_visual?.url || a.hero_image_url;
          return (
            <Link key={a.slug} to={toArticle(a.slug)} data-testid={`security-card-${a.slug}`}
              onClick={() => sectorTrack("security_story_click", a.slug, "defi")}
              className="group flex flex-col rounded-xl border border-[#EF4444]/25 bg-[#0b0c10] p-4 hover:border-[#EF4444]/60 transition-colors">
              <div className="flex items-center gap-2">
                <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[#EF4444]" />
                <span className="font-mono text-[9px] font-bold uppercase tracking-[0.2em] text-[#EF4444]">Security</span>
              </div>
              <p className="font-news font-bold text-white text-[14.5px] leading-snug mt-2.5 line-clamp-3 group-hover:text-[#EF4444] transition-colors">
                {a.title}
              </p>
              <p className="font-mono text-[9.5px] text-gray-500 mt-auto pt-3">{timeAgo(a.published_at)}</p>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
